export default __webpack_public_path__ + "static/media/logo.3cdcf42e.svg";